import { render } from "./SloganCard.vue?vue&type=template&id=aad7cdfe"
import script from "./SloganCard.vue?vue&type=script&lang=js"
export * from "./SloganCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__